import React, { useEffect, useState } from 'react';

// import i18n from '../../i18n';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import styles from './DistrictMap.module.scss';
import LeafletMap from '../LeafletMap';
import DistrictSlideCard from '../DistrictSlideCard';
import { dataLayerPush } from '../../utils/datalayer';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import geojsonLocation from '../../utils/locations';

import SwiperCore, { EffectFade } from 'swiper';
import 'swiper';
import Icon from '../Icon';

SwiperCore.use([EffectFade]);

const DistrictMap = ({ cards, title, preamble }) => {
    const [selectedPolygon, setSelectedPolygon] = useState(0);
    const [isHidden, setIsHidden] = useState(false);
    const [swiper, setSwiper] = useState(null);
    const [viewportWidth, setViewportWidth] = useState();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setViewportWidth(window.innerWidth);
        }
    }, []);
    const handleNextNav = (swiper) => {
        if (swiper) {
            swiper.slideNext();
            setSelectedPolygon(selectedPolygon);
        }
    };

    const handlePrevNav = (swiper) => {
        if (swiper) {
            swiper.slidePrev();
            setSelectedPolygon(selectedPolygon);
        }
    };

    const handleCloseCard = () => {
        setIsHidden(true);
    };

    const handleShowCard = () => {
        setIsHidden(false);
    };

    const sliderSettings = {
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            350: {
                slidesPerView: 'auto',
            },
        },
        speed: 200,
        effect: 'fade',
        navigation: {
            prevEl: '.' + styles['CardSlider__Button--Prev'],
            nextEl: '.' + styles['CardSlider__Button--Next'],
        },
        watchSlidesVisibility: true,
        allowSlideNext: true,
        allowSlidePrev: true,
        allowTouchMove: false,
    };

    const mobileSliderSettings = {
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
            350: {
                slidesPerView: 'auto',
            },
        },
        speed: 200,
        navigation: {
            prevEl: '.' + styles['CardSlider__Button--Prev'],
            nextEl: '.' + styles['CardSlider__Button--Next'],
        },
        watchSlidesVisibility: true,
    };

    if (!cards || cards.length === 0) {
        return null;
    }

    const handleChildClick = (selectedPolygon) => {
        setSelectedPolygon(selectedPolygon);
        if (swiper && swiper.slideTo) {
            swiper.slideTo(selectedPolygon);
        }
    };

    const className = classNames(styles['DistrictMap']);

    const closeButtonClass = classNames(
        styles['DistrictMap__Close'],
        styles['DistrictMap__Close--Hidden']
    );

    return (
        <div className={className}>
            <div className={styles['DistrictMap__Container']}>
                <h2 className={styles['DistrictMap__Title']}>{title}</h2>
                <p className={styles['DistrictMap__Text']}>{preamble}</p>
                <div className={styles['DistrictMap__MapContainer']}>
                    <div className={styles['DistrictMap__Map']}>
                        <LazyLoad once offset={100}>
                            <LeafletMap
                                geojson={geojsonLocation}
                                onChildClick={(selectedPolygon) => {
                                    handleChildClick(selectedPolygon);
                                    handleShowCard();
                                }}
                                viewport={
                                    viewportWidth > 1023
                                        ? { zoom: 13, center: [59.32, 18.07] }
                                        : { zoom: 12, center: [59.33, 18.07] }
                                }
                                selectedPolygon={selectedPolygon}
                                mapStyle="100vh"
                            />
                        </LazyLoad>
                    </div>
                    <div className={styles['DistrictMap__Card']}>
                        <div className={styles['DistrictMap__SwiperContainer']}>
                            {sliderSettings && (
                                <Swiper
                                    {...sliderSettings}
                                    onSwiper={setSwiper}>
                                    <div
                                        className={
                                            styles[
                                                'DistrictMap__ButtonContainer'
                                            ]
                                        }>
                                        <div
                                            className={classNames(
                                                styles['DistrictMap__Button'],
                                                styles[
                                                    'DistrictMap__Button--Prev'
                                                ]
                                            )}
                                            onClick={() => {
                                                handlePrevNav(swiper);
                                                setSelectedPolygon((prev) => {
                                                    const newValue = prev - 1;
                                                    return newValue < 0
                                                        ? 0
                                                        : newValue;
                                                });
                                            }}></div>
                                        <div
                                            className={classNames(
                                                styles['DistrictMap__Button'],
                                                styles[
                                                    'DistrictMap__Button--Next'
                                                ]
                                            )}
                                            onClick={() => {
                                                handleNextNav(swiper);
                                                setSelectedPolygon((prev) => {
                                                    const newValue = prev + 1;
                                                    return newValue > 6
                                                        ? 6
                                                        : newValue;
                                                });
                                            }}></div>
                                    </div>
                                    <button
                                        className={closeButtonClass}
                                        onClick={handleCloseCard}>
                                        <Icon
                                            type="close"
                                            color="black"
                                            size="large"
                                        />
                                    </button>
                                    {cards.map((card, i) => (
                                        <SwiperSlide
                                            key={i}
                                            className={
                                                isHidden
                                                    ? styles[
                                                          'DistrictMap__SwiperSlide--Hidden'
                                                      ]
                                                    : styles[
                                                          'DistrictMap__SwiperSlide'
                                                      ]
                                            }>
                                            {({ isActive }) => (
                                                <div
                                                    className={classNames(
                                                        styles[
                                                            'DistrictMap__SwiperSlideWrapper'
                                                        ],
                                                        {
                                                            [styles[
                                                                'DistrictMap__SwiperSlideWrapper--Active'
                                                            ]]: isActive,
                                                        }
                                                    )}>
                                                    <DistrictSlideCard
                                                        image={card.image}
                                                        label={card.label}
                                                        title={card.title}
                                                        text={card.text}
                                                        link={card.link}
                                                        tags={card.tags}
                                                    />
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
DistrictMap.propTypes = {
    cards: PropTypes.array.isRequired,
    geojson: PropTypes.object,
    title: PropTypes.string.isRequired,
    preamble: PropTypes.string,
};

export default DistrictMap;
